import React, { useState } from 'react';
import { useUser } from '../utils/UserContext';
import TabBar from '../components/shared/TabBar';
import InnerTabsd from '../components/shared/InnerTabsd';
import { UserIcon2 } from '../components/shared/Icons';
import { SupervisorProvider, SuperSlots, SuperResponses, SuperRoster, SuperMessages } from './SupervisorAvailability';
import { CreateCasualJobs } from './CreateCasualJobs';
import { JobsCountBadge, OpenSlotsBadge, ToApproveBadge, MessagesBellBadge } from './superTabBadges';

const TABS = [
  { id: 'workavailablesuperd', label: 'Casual Jobs' },
];

const SUPER_INNER = [
  // placeholder = the live count / bell after the label (InnerTabsd renders it inside the provider)
  { id: 'createjobsd', label: 'Create Jobs', icon: <UserIcon2 />, component: CreateCasualJobs, placeholder: JobsCountBadge },
  { id: 'openslotsd',  label: 'Open Slots',  icon: <UserIcon2 />, component: SuperSlots,       placeholder: OpenSlotsBadge },
  { id: 'responsesd',  label: 'Responses',   icon: <UserIcon2 />, component: SuperResponses,   placeholder: ToApproveBadge },
  { id: 'rosterd',     label: 'Roster',      icon: <UserIcon2 />, component: SuperRoster },
  { id: 'messagesd',   label: 'Messages',    icon: <UserIcon2 />, component: SuperMessages,    placeholder: MessagesBellBadge },
];

const FilterAvailablesuperd = () => {
  const [activeTab, setActiveTab] = useState('workavailablesuperd');
  const { homeAccent } = useUser();

  return (
    <div className="fr-tab-page">
      <TabBar tabs={TABS} activeTab={activeTab} onTabChange={setActiveTab} homeRoute="/profile" homeColor={homeAccent} />
      <div className="fr-tab-content">
        {activeTab === 'workavailablesuperd' && (
          <SupervisorProvider>
            <InnerTabsd tabs={SUPER_INNER} defaultId="createjobsd" />
          </SupervisorProvider>
        )}
      </div>
    </div>
  );
};

export default FilterAvailablesuperd;